module.exports = __webpack_public_path__ + "media/images/BSCF_logo-b7b2baf84740357a4e794c2c4e08154b.png";